import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/subdomain/admin/_staff/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/subdomain/admin/settings/profile' });
  },
});
